import { Box } from "@mui/system"
import { MainPageContentContainer } from "components/MainPageContentContainer"
import { SessionsContainer } from "layouts/sessions/container"
import { SessionsPageProvider } from "layouts/sessions/context/provider"
import { SaveAltOutlined } from "@mui/icons-material"
import { OreveButton } from "components/button/OreveButton.tsx"
import { FilterSessions } from "layouts/sessions/filter/FilterSessions"
import { useSessionsContext } from "layouts/sessions/context/sessions-context.ts"
import { OreveFooter } from "components/OreveFooter.tsx"
import { useOrganization } from "context/OrganizationContext.tsx"

export const SessionsPage = () => {
    const { organizationId } = useOrganization()

    return (
        <SessionsPageProvider key={organizationId ?? "no-org"}>
            <SessionsPageView />
        </SessionsPageProvider>
    )
}

const SessionsPageView = () => {
    const { setExportFilterSession, isLoading, filterValues } =
        useSessionsContext()
    const downloadCsv = () => {
        setExportFilterSession({
            export: true,
            filter: filterValues,
        })
    }
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                marginBottom: "5rem",
            }}
        >
            <FilterSessions />
            <MainPageContentContainer
                sx={{
                    p: "2.25rem",
                }}
            >
                <SessionsContainer />
            </MainPageContentContainer>
            <OreveFooter>
                <OreveButton
                    data-testid="download_sessions_csv"
                    data-cy="session__footer--downloadcsv"
                    loading={isLoading}
                    onClick={downloadCsv}
                    variant="outlined"
                    value="Exporter en format .csv"
                    icon={SaveAltOutlined}
                />
            </OreveFooter>
        </Box>
    )
}
